import React from "react";
import collectionImg from "../../../assets/collection_img_1.png";
import verifyImg from "../../../assets/verify.png";
import solanaIcon from "../../../assets/solanaIcon.svg";
import leftArrow from "../../../assets/leftArrow.svg";
import addIcon from "../../../assets/addIcon.svg";
import { newest } from "../../../mock/newest";
import NewestCollection from "../../../components/_home/NewestCollection/NewestCollection";
import styles from "./Main.module.scss";
import { useNavigate } from "react-router-dom";

const Main = () => {
  const navigate = useNavigate();
  return (
    <main className={styles.container}>
      <div className={styles.infoContainer}>
        <div className={styles.leftArrow}>
          <img src={leftArrow} alt="go-back" />
        </div>
        <img
          src={collectionImg}
          alt="collection"
          className={styles.collectionImg}
        />
        <h1>
          Cryptographics <img src={verifyImg} alt="verified" />
        </h1>
        <small>
          Created by <strong>Tyler Smith</strong>
        </small>
        <div className={styles.cards}>
          <div className={styles.card}>
            <h4>233</h4>
            <p>Total NFTs</p>
          </div>
          <div className={styles.card}>
            <h4>16</h4>
            <p>Owners</p>
          </div>
          <div className={styles.card}>
            <h4>
              <img src={solanaIcon} alt="solana" />
              7.0
            </h4>
            <p>Solana Traded</p>
          </div>
        </div>
        <p>
          These are 2134 cryptographics which is all my favorite personal
          collection it includes gifs, videos and music.
        </p>
      </div>

      <div className={styles.filter}>
        <select>
          <option value="all">All</option>
          <option value="bundles">Bundles</option>
        </select>
        <select>
          <option value="lowToHigh">Low to high</option>
          <option value="HighToLow">High to Low</option>
        </select>
      </div>

      <div className={styles.itemsContainer}>
        {newest.map((i) => (
          <NewestCollection
            key={i.id}
            name={i.name}
            creator={i.creator}
            media={i.media}
            type={i.type}
            price={i.price}
            likes={i.likes}
          />
        ))}
        <img
          src={addIcon}
          alt="add item"
          className={styles.add}
          onClick={() => navigate("/upload-nft")}
        />
      </div>
    </main>
  );
};

export default Main;
